// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { convertToCustomQuote as convertQuote, CreateCustomQuote } from "@bg/App/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";

interface Props {
    apiParameter: CreateCustomQuote;
    apiResult: { successful: boolean; error?: any; customQuoteId?: string | undefined };
}

type Parameter = CreateCustomQuote & {
    onSuccess?: () => void;
    onComplete?: (result: any) => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingquotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyCustomQuotes/BeginCreatingCustomQuote",
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await convertQuote(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteCreatingCustomQuote",
        } as any);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const RedirectOnComplete: HandlerType = props => {
    if (props.apiResult.successful && props.apiResult.customQuoteId) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteCreatingCustomQuote",
        } as any);
        const requestQuotePageUrl = getPageLinkByPageType(props.getState(), "MyCustomQuoteDetailsPage")?.url;
        if (requestQuotePageUrl) {
            window.location.href = `${requestQuotePageUrl}?id=${props.apiResult.customQuoteId}`;
        }
    }
};

export const chain = [BeginLoadingquotes, DispatchBeginAction, CallApiWithParameters, OnError, RedirectOnComplete];

const convertToCustomQuote = createHandlerChainRunner(chain, "ConvertToCustomQuote");
export default convertToCustomQuote;
